import request from '../request'
import {RES_OK} from '@/api/config'

const d = ({data}) => {
  return data.code === RES_OK ? data.data : null
}
// 修改baseUrl
const config = {
  baseURL: '/api/invitation/prizewheel'
}

// 随机数，返回一个int 类型，interval 是区间
export function random(interval) {
  return Math.floor(Math.random() * interval)
}

// 获取活动信息
export function getActivityInfo() {
  const url = '/getactivityinfo'
  return request.get(url, config).then(d)
}

// 开始抽奖
// 1=年卡会员 2=月卡及半年卡会员
export function draw(type) {
  const url = '/draw'
  return request.post(url, {
    draw_type: type
  }, config).then(d)
}

// 查看我的中奖记录
export function getMyGift() {
  const url = '/getMyPrize'
  return request.get(url, config).then(d)
}

// 其他人中奖列表
export function getOtherList() {
  const url = '/getPrizeList'
  return request.get(url, config).then(d)
}


// WEBPACK FOOTER //
// ./src/api/activity/rotate.js